export default __webpack_public_path__ + "static/cashflow_new_11-2b2b1f357125941610b66b59fbf3d756.jpg";